module.exports = __webpack_public_path__ + "static/blog8-41d21e0010f68e55f299f15584f710ec.png";